import { api } from "../apiCore";

export const scoringApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // сделать первый скоринг
    sendDataToScoring: builder.mutation<
      { code: string; message: string },
      { applicationBankId: number }
    >({
      query: (value) => ({
        url: `/auth/scoring-processing/${value.applicationBankId}`,
        method: "POST",
        body: {
          status: "primary",
        },
      }),
      invalidatesTags: ["ApplicationBank"],
    }),
  }),
});

export const { useSendDataToScoringMutation } = scoringApi;
